import * as React from "react";
import { SignatureData } from "intake_shared/src/types";
import SignatureForm from "../SignatureForm/SignatureForm";
import SignaturePreview from "../SignaturePreview/SignaturePreview";
import styles from "./CreateSignature.module.scss";
import { AclContext } from "../../../../../contexts/AclContext";

interface CreateSignatureProps {
    mode?: "create" | "edit";
    signatureInView?: SignatureData;
    setEditSignature?: (val: boolean) => void;
}

export default function CreateSignature({
    mode = "create",
    signatureInView,
    setEditSignature,
}: CreateSignatureProps) {
    const loggedInUserEmail = React.useContext(AclContext)?.authUser.user?.email;
    const userAcl = React.useContext(AclContext)?.authUser?.acl;
    const [currentSignature, setCurrentSignature] = React.useState<SignatureData>({
        id: "",
        name: "",
        pronouns: "",
        company: "",
        department: "",
        phone: "",
        directPhone: "",
        email: userAcl?.super_admin ? "" : (loggedInUserEmail as string),
        includeDisclaimer: true,
    });

    return (
        <div className={styles.container}>
            <SignatureForm
                initialData={
                    mode === "create"
                        ? currentSignature
                        : signatureInView || ({} as SignatureData)
                }
                mode={mode}
                setCurrentSignature={setCurrentSignature}
                setEditSignature={setEditSignature}
            />
            <SignaturePreview signature={currentSignature} />
        </div>
    );
}
